import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BACKEND_URL } from "../Config/Config";

const getUserDetails = () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  return JSON.parse(userDetails);
};

const updatePriorityTag = async ({ testCaseId, priority, tags }) => {
  const user = getUserDetails();

  const response = await axios.put(
    `${API_BACKEND_URL}/testcase/updatePriorityAndTagsForTC?companyId=${user.companyid}`,
    {
      testCaseId: testCaseId,
      priority: priority,
      tags: tags,
    },
  );
  return response.data;
};

export const useUpdatePriorityTag = (options = {}) => {
  return useMutation({
    mutationFn: updatePriorityTag,
    ...options,
  });
};
